export const BREAKPOINTS = {
  TABLET_BREAKPOINT: 993,
  HUAWEI_MEDIAPAD: 938,
  HUAWEI_MATEPAD_10_4: 855,
  MOBILE_BREAKPOINT: 480,
  LENOVO_TAB_V7: 478,
}
